module.exports = __webpack_public_path__ + "static/media/thum_4.96bae8cd.jpg";